"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@tiendanube/icons");
var ImageGallery_Item_1 = __importDefault(require("./ImageGallery.Item"));
require("./ImageGallery.css");
var __1 = require("..");
function ImageGallery(_a) {
    var name = _a.name, _b = _a.loading, loading = _b === void 0 ? false : _b, children = _a.children, emptyLabel = _a.emptyLabel, _c = _a.maxItems, maxItems = _c === void 0 ? 6 : _c, skeleton = _a.skeleton, onAddImage = _a.onAddImage;
    var id = "nimbus--input-" + name;
    var renderSpinnerEmpty = loading ? (React.createElement(__1.Spinner, { size: "medium", appearance: "secondary" })) : (React.createElement(React.Fragment, null,
        React.createElement(icons_1.CameraIcon, { size: "large" }),
        React.createElement(__1.Text, { bold: true, appearance: "secondary" }, emptyLabel)));
    var renderSpinnerAdd = loading ? (React.createElement(__1.Spinner, { size: "medium", appearance: "secondary" })) : (React.createElement(icons_1.PlusCircleIcon, { size: "large" }));
    var childrenCount = React.Children.count(children);
    var renderInputFile = function (spinner, className) {
        var fileInputClassName = classnames_1.default("nimbus--image-gallery__file-button", {
            "is--loading": loading,
        });
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "nimbus--image-gallery-item" },
                React.createElement("label", { htmlFor: id, className: fileInputClassName },
                    React.createElement("button", { name: id, "aria-label": id, id: id, type: "button", disabled: loading, onClick: onAddImage }),
                    spinner))));
    };
    var renderSkeletonItem = (React.createElement("div", { className: "nimbus--image-gallery-item__wrapper" },
        React.createElement("div", { className: "nimbus--image-gallery-item" },
            React.createElement("div", { className: "nimbus--image-gallery-skeleton__wrapper" },
                React.createElement("div", { className: "nimbus--image-gallery-skeleton" })))));
    var renderSkeleton = (React.createElement("div", { className: "nimbus--image-gallery__empty" },
        React.createElement("div", { className: "nimbus--image-gallery-skeleton" })));
    var renderChildren = (React.createElement("div", { className: "nimbus--image-gallery__row" },
        children,
        skeleton
            ? renderSkeletonItem
            : childrenCount < maxItems &&
                renderInputFile(renderSpinnerAdd, "nimbus--image-gallery-item__wrapper")));
    var renderEmpty = skeleton
        ? renderSkeleton
        : renderInputFile(renderSpinnerEmpty, "nimbus--image-gallery__empty");
    return (React.createElement("div", { className: "nimbus--image-gallery__wrapper" }, childrenCount ? renderChildren : renderEmpty));
}
ImageGallery.Item = ImageGallery_Item_1.default;
exports.default = ImageGallery;
//# sourceMappingURL=index.js.map